import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#44403C\" d=\"m13 4.219 2.728-2.997L18.69 3.92l-2.727 2.997z\"></path><path stroke=\"#44403C\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.67\" d=\"M17.645 5.677a2.349 2.349 0 1 0-3.322-3.323L3.202 13.478c-.194.193-.337.43-.417.692l-1.1 3.627a.417.417 0 0 0 .518.518l3.628-1.1c.26-.08.498-.222.691-.414L17.645 5.677ZM12.5 4.167 15.833 7.5\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h20v20H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }